import React from 'react';

import { Pane, Text, Pill } from 'evergreen-ui';

/**
 * Shared component for displaying product and card previews
 * Used by both CartPreview and OrderPreview
 * 
 * @param {Object} props
 * @param {Array} props.products - Array of product items
 * @param {Array} props.cards - Array of card items
 * @param {string} props.emptyText - Text to display when no items (default: "Nu are produse")
 * @param {Function} props.getProductQuantity - Function to extract quantity from product item
 * @param {Function} props.getCardQuantity - Function to extract quantity from card item
 * @param {string} props.productImageBucket - Environment variable or base URL for product images
 * @param {string} props.cardImageBucket - Environment variable or base URL for card images
 * @param {string} props.productImagePrefix - Prefix for product image filenames (default: "thumb_")
 * @param {string} props.productImageSuffix - Suffix for product image filenames (default: ".webp")
 */
export default function ItemsPreview(props) {
    const {
        products = [],
        cards = [],
        emptyText = "Nu are produse",
        getProductQuantity = (product) => product.quantity,
        getCardQuantity = (card) => card.quantity,
        productImageBucket = process.env.REACT_APP_PRODUCT_IMAGE_BUCKET,
        cardImageBucket = process.env.REACT_APP_CARD_IMAGE_BUCKET,
        productImagePrefix = 'thumb_',
        productImageSuffix = '.webp'
    } = props;

    return <Pane display="flex" padding={10} maxWidth={1200}  maxHeight="430px" overflowY="auto" flexWrap="wrap" justifyContent="center" alignContent="flex-start">
        {products.length > 0 ?
            products.map((product, index) => (
                <Pane key={product.id || index} marginRight={10} position="relative">
                    <img style={{height: '128px', width: 'auto'}}
                        alt={product.title || 'Product Thumbnail'}
                        src={
                            product.thumbnail ?
                                productImageBucket + '/' + productImagePrefix + product.thumbnail + productImageSuffix
                                : null
                        }/>
                    <Pill margin={5} color="red" position="absolute" left="0" bottom="0">{getProductQuantity(product)}</Pill>
                </Pane>
            )) : cards.length === 0 ? <div><Text>{emptyText}</Text></div> : null
        }

        {cards.length > 0 ?
            cards.map((card, index) => (
                <Pane key={card.id || index} marginRight={10} position="relative">
                    <img style={{height: '128px', width: 'auto'}}
                        alt={card.name || 'Card'}
                        src={
                            card.thumbnail ?
                                cardImageBucket + '/' + card.thumbnail
                                : null
                        }/>
                    <Pill margin={5} color="red" position="absolute" left="0" bottom="0">{getCardQuantity(card)}</Pill>
                </Pane>
            )) : products.length === 0 ? <div><Text>{emptyText}</Text></div> : null
        }
    </Pane>
}
